import { backdropClasses, Theme } from "@mui/material";
import { colors } from "../../constants/colors";
import zIndex from "@mui/material/styles/zIndex";
import { trace } from "console";

const styles = {
  '& #tab-content': {
    backgroundColor: colors.tertiary,
    color: colors.black,
  },
  '& #tabbar-container': {
    backgroundColor: colors.white
  },
  '& #tabbar-inner-container': {
    backgroundColor: colors.tertiary
  },
  '& button.active-tab': {
    color: `${colors.white} !important`,
    backgroundColor: `${colors.primary} !important`
  },
  '& #tab': {
    transition: 'all 0.3s ease',
    backgroundColor: colors.tertiary,
    color: colors.black,
    cursor: 'pointer'
  },
  '@media (min-width: 1024px)': {
    '& #tab-content': {
      backgroundColor: colors.tertiary,
    },
    '& #tabbar-container': {
      backgroundColor: colors.tertiary
    },
    '& #tab': {
      backgroundColor: colors.tertiary,
    },
    '& #tabbar-inner-container': {
      backgroundColor: colors.tertiary
    },
    '& .active-tab': {
      color: colors.white,
      backgroundColor: `${colors.primary} !important`
    },
  },
};

const tabbarStyles: any = (theme?: Theme) => styles;

export default tabbarStyles;